import React, { useState, useEffect } from 'react';
import {FormComponent} from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';
import Select from 'react-select'
import { changedDocumentService } from '../services';

const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
  { value: 'pear', label: 'Pear' }
]

const ReTestGridComponent = ({
  document,
  fieldValue,
  template,
  fieldName,
  formParameters,
  key,
  responsiveLayouts,
  message,
  componentDefinition
}) => {

  const [value, setValue] = useState();

  useEffect(() => {
    if (fieldValue) {
      setValue(fieldValue);
    } else if (componentDefinition.defaultValue) {
      setValue(componentDefinition.defaultValue);
    }
  }, []);

  return (    
    <Select options={options} 
      value={value}
      onChange={(e: any) => {
        const newValue = e.value;

        changedDocumentService.valueChanged({
          document,
          fieldName,
          fieldValue,
          formParameters,
          template,
          componentDefinition,
          key
        }, newValue);

        setValue(newValue);
      }}
    />
  );
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('re-test-grid', ReTestGridComponent);

export default ReTestGridComponent;
